import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useNotificationCount } from "src/shared/store/notification/composables";
import Session from "js/Session";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationBubble',
    setup(__props) {
        const count = useNotificationCount(Session.getInstance().getUserId());
        const notificationCount = computed(() => {
            return count.count > 99 ? "99" : count.count;
        });
        const goToNotificationsPage = () => {
            window.location.href = "/notifications";
        };
        return (_ctx, _cache) => {
            return (_unref(count).count > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "notification-bubble",
                    onClick: _withModifiers(goToNotificationsPage, ["prevent", "stop"])
                }, _toDisplayString(notificationCount.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true);
        };
    }
});
